import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
} from '@angular/core'
import { financeStatus } from '../../models/finance.enum'
import { TranslateService } from '@ngx-translate/core'

@Component({
	selector: 'app-finance-payment-method-filter',
	templateUrl: './finance-payment-method-filter.component.html',
	styleUrls: ['./finance-payment-method-filter.component.scss'],
})
export class FinancePaymentMethodFilterComponent implements OnInit, OnChanges {
	@Input() totals: any = {
		totalOnline: 0,
		totalCash: 0,
		totalPromos: 0,
		totalAddedFund: 0,
		totalSubtractedFund: 0,
		totalCashback: 0,
		currency: {
			id: 0,
			name: 0,
		},
	}

	@Output() emitActiveStatus: EventEmitter<any> = new EventEmitter<any>()
	currency: any
	financeStatus = financeStatus
	@Input() activeStatus: number = 1
	totalsArray: any
	imgPaths: any = [
		'./assets/images/card.svg',
		'./assets/images/cash-icon.png',
		'./assets/images/discount.svg',
		'./assets/images/card-add.svg',
		'./assets/images/card-remove.svg',
		'./assets/images/money-recive.svg',
	]
	constructor(public translate: TranslateService) {}

	ngOnInit(): void {}
	ngOnChanges(changes: SimpleChanges): void {
		this.currency = this.totals?.currency
		// delete this.totals?.currency
		this.totals ? (this.totalsArray = Object?.values(this?.totals)) : ''
	}
}
